module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/en/2-bc8b29ccc3b32a330fdd8c69cb66eff1.jpg";